import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface JiraDeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedCount: number;
  isLoading?: boolean;
}

const JiraDeleteConfirmDialog: React.FC<JiraDeleteConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedCount,
  isLoading = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Подтвердите удаление</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Вы уверены, что хотите удалить {selectedCount}{' '}
          {selectedCount === 1 ? 'задачу' : selectedCount < 5 ? 'задачи' : 'задач'}?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Это действие нельзя отменить.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Отмена
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Удаление...' : 'Удалить'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default JiraDeleteConfirmDialog;
